/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type AdPassengerRowCustomerFragment = {
  __typename?: 'Customer'
  firstName: string | null
  lastName: string | null
  extendedWalkingTime: boolean
  visualImpairment: boolean | null
}

export const AdPassengerRowCustomerFragmentDoc = gql`
    fragment AdPassengerRowCustomer on Customer {
  firstName
  lastName
  extendedWalkingTime
  visualImpairment
}
    `
